import React from "react";
import {
  actionLoadScene,
  actionShortcuts,
} from "@excalidraw/excalidraw/actions";
import { useExcalidrawActionManager } from "@excalidraw/excalidraw/components/App";
import {
  ExternalLinkIcon,
  LoadIcon,
  HelpIcon,
} from "@excalidraw/excalidraw/components/icons";
import { workspaceText } from "@excalidraw/excalidraw/components/workspaceText";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
export const AppWelcomeScreen: React.FC = React.memo(() => {
  const { langCode } = useI18n();
  const actions = useExcalidrawActionManager();
  return (
    <WelcomeScreen>
      <WelcomeScreen.Center>
        <section
          className="studio-welcome"
          aria-labelledby="studio-welcome-title"
        >
          <div className="studio-welcome-art" aria-hidden="true">
            <svg viewBox="0 0 220 116" fill="none">
              <rect x="30" y="15" width="65" height="70" rx="12" />
              <path d="M49 37h27M49 48h17M49 65h23" />
              <path
                className="studio-art-line"
                d="M91 60c25 0 17-31 42-31h14M137 20l12 9-12 9"
              />
              <rect
                className="studio-art-square"
                x="153"
                y="9"
                width="47"
                height="43"
                rx="10"
              />
              <circle className="studio-art-circle" cx="150" cy="86" r="22" />
              <path d="m139 86 8 8 15-17M59 97h29" />
              <circle className="studio-art-dot" cx="16" cy="41" r="3" />
              <circle className="studio-art-dot" cx="206" cy="85" r="3" />
            </svg>
          </div>
          <span className="studio-eyebrow">
            {workspaceText(langCode, "workspace")}
          </span>
          <h2 id="studio-welcome-title">
            {workspaceText(langCode, "welcomeTitle")}
          </h2>
          <p>{workspaceText(langCode, "welcomeBody")}</p>
          <div className="studio-welcome-actions">
            <button
              type="button"
              className="studio-open"
              data-testid="welcome-open"
              onClick={() => actions.executeAction(actionLoadScene)}
            >
              {LoadIcon}
              <span>{workspaceText(langCode, "open")}</span>
              <kbd>Ctrl O</kbd>
            </button>
            <button
              type="button"
              data-testid="welcome-help"
              onClick={() => actions.executeAction(actionShortcuts)}
            >
              {HelpIcon}
              <span>{workspaceText(langCode, "help")}</span>
              <kbd>?</kbd>
            </button>
          </div>
          <a
            className="studio-welcome-hub"
            href="https://opusdeskhub.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {workspaceText(langCode, "hub")}
            {ExternalLinkIcon}
          </a>
          <small>{workspaceText(langCode, "welcomeHint")}</small>
        </section>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
